import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';

// StrictMode stays (Zonive convention — see PSCraft "do not remove StrictMode").
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
